<template>
  <div>
    <el-dialog
        :title="fullNameTitle"
        :visible.sync="dialogVisible"
        width="1000px"
        :before-close="closeDialog"
        :close-on-click-modal="false"
        top="8vh"
    >
      <el-form
          label-width="120px"
          :model="attendanceKid"
          label-position="top"
          ref="attendanceKid"
      >
        <el-row :gutter="20" style="margin-top: 10px">
          <!-- Card Điểm danh đến -->
          <el-col :span="24">
            <div class="shift-card">
              <div class="shift-header">
                <strong>Điểm danh đến</strong>
              </div>

              <div class="shift-row two-columns">
                <!-- Ảnh đến -->
                <div class="shift-col shift-media">
                  <div class="shift-media-title">Ảnh đến</div>
                  <image-uploader
                      :preview="attendanceKid.attendanceArriveKids.arriveUrlPicture"
                      placeholder="Chưa có ảnh đến"
                      :updateAttendance="false"
                  />
                  <div class="shift-time">
                    Giờ đến: <span>{{ attendanceKid.attendanceArriveKids.timeArriveKid | formatTime }}</span>
                  </div>
                </div>

                <!-- Ghi chú đến + thông tin -->
                <div class="shift-col shift-note">
                  <div class="shift-media-title">Nội dung ghi chú đến</div>
                  <el-input
                      type="textarea"
                      :rows="4"
                      placeholder="Chưa có ghi chú"
                      v-model="attendanceKid.attendanceArriveKids.arriveContent"
                      disabled
                  />

                  <div class="shift-status" style="margin-top: 20px" v-if="attendanceKid.attendanceArriveKids.idCreated != null">
                    <div v-if="attendanceKid.attendanceArriveKids.createdDate !== attendanceKid.attendanceArriveKids.lastModifieDate">
                      Điểm danh lần cuối: <strong>{{ attendanceKid.attendanceArriveKids.lastModifieBy }}</strong>
                      <br />
                      <span v-if="attendanceKid.attendanceArriveKids.lastModifieBy !== 'Hệ thống'">
                      Thời gian: {{ attendanceKid.attendanceArriveKids.lastModifieDate | formatDateTime }}
                      </span>
                      <div v-if="attendanceKid.attendanceArriveKids.guardianPerson">
                        Người đưa đến: <strong>{{ attendanceKid.attendanceArriveKids.guardianPerson }}</strong>
                      </div>
                    </div>
                    <div v-else>
                      Điểm danh: <strong>{{ attendanceKid.attendanceArriveKids.createdBy }}</strong>
                      <br />
                      <span v-if="attendanceKid.attendanceArriveKids.createdBy !== 'Hệ thống'">
                      Thời gian: {{ attendanceKid.attendanceArriveKids.createdDate | formatDateTime }}
                      </span>
                      <div v-if="attendanceKid.attendanceArriveKids.guardianPerson">
                        Người đưa đến: <strong>{{ attendanceKid.attendanceArriveKids.guardianPerson }}</strong>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <el-divider />
          </el-col>

          <!-- Card Điểm danh về (chỉ hiển thị nếu có dữ liệu) -->
          <el-col :span="24" v-if="attendanceKid.attendanceLeaveKids && attendanceKid.attendanceLeaveKids.idCreated != null">
            <div class="shift-card">
              <div class="shift-header">
                <strong>Điểm danh về</strong>
              </div>

              <div class="shift-row two-columns">
                <!-- Ảnh về -->
                <div class="shift-col shift-media">
                  <div class="shift-media-title">Ảnh về</div>
                  <image-uploader
                      :preview="attendanceKid.attendanceLeaveKids.leaveUrlPicture"
                      placeholder="Chưa có ảnh về"
                      :updateAttendance="false"
                  />
                  <div class="shift-time">
                    Giờ về: <span>{{ attendanceKid.attendanceLeaveKids.timeLeaveKid | formatTime }}</span>
                  </div>
                </div>

                <!-- Ghi chú về + thông tin -->
                <div class="shift-col shift-note">
                  <div class="shift-media-title">Nội dung ghi chú về</div>
                  <el-input
                      type="textarea"
                      :rows="4"
                      placeholder="Chưa có ghi chú"
                      v-model="attendanceKid.attendanceLeaveKids.leaveContent"
                      disabled
                  />

                  <div class="shift-status" style="margin-top: 20px" v-if="attendanceKid.attendanceLeaveKids.idCreated != null">
                    <div v-if="attendanceKid.attendanceLeaveKids.createdDate !== attendanceKid.attendanceLeaveKids.lastModifieDate">
                      Điểm danh lần cuối: <strong>{{ attendanceKid.attendanceLeaveKids.lastModifieBy }}</strong>
                      <br />
                      <span v-if="attendanceKid.attendanceLeaveKids.lastModifieBy !== 'Hệ thống'">
                      Thời gian sửa: {{ attendanceKid.attendanceLeaveKids.lastModifieDate | formatDateTime }}
                      </span>
                      <span v-else>
                      Thời gian sửa: {{ attendanceKid.attendanceLeaveKids.timeLeaveKid | formatTime }}
                      </span>
                      <div v-if="attendanceKid.attendanceLeaveKids.guardianPerson">
                        Người đưa về: <strong>{{ attendanceKid.attendanceLeaveKids.guardianPerson }}</strong>
                      </div>
                    </div>
                    <div v-else>
                      Điểm danh: <strong>{{ attendanceKid.attendanceLeaveKids.createdBy }}</strong>
                      <br />
                      <span v-if="attendanceKid.attendanceLeaveKids.createdBy !== 'Hệ thống'">
                      Thời gian: {{ attendanceKid.attendanceLeaveKids.createdDate | formatDateTime }}
                      </span>
                      <span v-else>
                      Thời gian: {{ attendanceKid.attendanceLeaveKids.timeLeaveKid | formatTime }}
                      </span>
                      <div v-if="attendanceKid.attendanceLeaveKids.guardianPerson">
                        Người đưa về: <strong>{{ attendanceKid.attendanceLeaveKids.guardianPerson }}</strong>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="danger" size="medium" @click="closeDialogByButton('attendanceKid')">
          <i class="el-icon-circle-close" /> Đóng
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import AttendanceService from "@/services/AttendanceService";
import ImageUploader from "@/utils/view/ImageUploader.vue";

export default {
  components: {ImageUploader},
  props: {
    dialogVisible: null,
  },
  data() {
    return {
      attendanceKid: {
        attendanceArriveKids: {
          idCreated: ""
        },
        attendanceLeaveKids: {
          idCreated: ""
        },
      },
      attendanceSave: {},
      fullNameTitle: "",
      loadingButton: false,
      dialogVisibleImg: false,
      urlPictureUser: "",
    };
  },
  methods: {
    showPictureOnDevice(url) {
      console.log(url)
      this.urlPictureUser = url;
      this.dialogVisibleImg = true;
    },
    //reset when click x
    closeDialog() {
      this.$emit("dialog-close", false);
      setTimeout(() => {
        this.$refs["attendanceKid"].resetFields();
      }, 300);
    },
    //click when click button
    closeDialogByButton(fromData) {
      this.$emit("dialog-close", false);
      setTimeout(() => {
        this.$refs[fromData].resetFields();
      }, 300);
    },
    getDataArriveRowInitial(row) {
      this.attendanceKid = row;
      this.fullNameTitle =
          "Thông tin điểm danh đến và về: " + row.kids.fullName;
    },
  },
};
</script>
<style scoped>
/* ================================================
   CARD CHUNG
   ================================================ */
.shift-card {
  padding: 20px;
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #e0e7ff;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
  margin-bottom: 24px;
}

.shift-header {
  font-size: 18px;
  font-weight: 600;
  color: #1e40af;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e5efff;
}

.shift-row {
  display: flex;
  flex-wrap: wrap;
  gap: 32px;
  align-items: flex-start;
}

.shift-col.shift-media {
  flex: 0 0 180px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.shift-media-title {
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 10px;
  width: 100%;
}

.shift-time {
  margin-top: 10px;
  font-size: 14px;
  color: #3b82f6;
  font-weight: 500;
  width: 100%;
  text-align: center;
}

.shift-col.shift-note {
  flex: 1;
  min-width: 300px;
}

.shift-row.two-columns {
  justify-content: center;
  gap: 80px;
  padding: 0 40px;
}

.shift-status {
  margin-top: 20px;
  font-size: 13.5px;
  line-height: 1.7;
  color: #4b5563;
}

.shift-status strong {
  color: #1e40af;
}

/* Dialog style */
::v-deep .el-dialog {
  border-radius: 12px;
  overflow: hidden;
}

::v-deep .el-dialog__header {
  background: linear-gradient(135deg, #3b82f6, #1d4ed8);
  padding: 18px 24px !important;
}

::v-deep .el-dialog__title {
  color: white !important;
  font-size: 22px !important;
  font-weight: 600;
}

::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: white !important;
  font-size: 24px;
}

::v-deep .el-dialog__body {
  max-height: 70vh;
  overflow-y: auto;
  background: #f8fafc;
  padding: 20px 24px !important;
}

::v-deep .el-dialog__footer {
  background: #f1f5f9;
  padding: 16px 24px !important;
  border-top: 1px solid #e2e8f0;
  text-align: right;
}

::v-deep .el-button--danger {
  background: #ef4444;
  border-color: #ef4444;
}

::v-deep .el-button--danger:hover {
  background: #dc2626;
  border-color: #dc2626;
}

.el-divider {
  margin: 20px 0;
  background: #e2e8f0;
}

/* Responsive */
@media (max-width: 768px) {
  .shift-row.two-columns {
    flex-direction: column;
    align-items: center;
    gap: 40px;
    padding: 0 20px;
  }
  .shift-col.shift-media {
    width: 100%;
    max-width: 220px;
  }
}
</style>